// extracted by mini-css-extract-plugin
module.exports = {"vars":"'../../vars.css'","black":"#333333","secondary":"#C4942F","accent":"#4E1617","gray":"#F5F5F5","wrapper":"Footer-module--wrapper--3pSMT"};